export default __webpack_public_path__ + "static/media/btn_treasure.188d6231.png";